import { Accordion } from 'react-bootstrap';

const BaseAccordion = ({ eventKey = 0, header = '', bodyBackground = '', children }) => {
  return (
    <Accordion className="border-0 rounded-0">
      <Accordion.Item eventKey={eventKey}>
        <Accordion.Header>{header}</Accordion.Header>
        <Accordion.Body
          className="w-100 h-100 rounded-0"
          style={{ '--accordion-body-bg': bodyBackground }}
        >
          {children}
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default BaseAccordion;
